import {
    IAnalisesDeCreditoBody,
    IListarAnaliseDeCredito,
} from "../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import {
    AnaliseDeCreditoServices,
    ListarAnalistasDeCreditoServices,
} from "../../../Services/Vendas/AnaliseDeCredito/AnaliseDeCreditosServices";
import { Controller } from "../../Controller";

export async function AnaliseDeCreditoController(
    pagina: number,
    requestBody: IAnalisesDeCreditoBody
) {
    return Controller(
        AnaliseDeCreditoServices<IListarAnaliseDeCredito>(
            pagina,
            requestBody,
            false
        )
    );
}

export async function ExportarExcelAnaliseDeCreditoController(
    requestBody: IAnalisesDeCreditoBody
) {
    return Controller(AnaliseDeCreditoServices<Blob>(0, requestBody, true));
}

export async function ListarAnalistasDeCreditoController() {
    return Controller(ListarAnalistasDeCreditoServices());
}

